import { LessonPlan } from '@lessonup/typescript-core/domain';
import { sanitizeContent } from '@lessonup/typescript-core/utils';
import React from 'react';
import './css/LessonPlanText.less';

type Props = {
  child: LessonPlan.Children.Text;
};

const LessonPlanText: React.FC<Props> = ({ child }) => {
  const alignText = child.align ? `text-align-${child.align}` : 'text-align-left';
  const childText = sanitizeContent(child.text);
  return (
    <div
      className={`paragraph ${alignText} html auto-height no-border lesson-plan-text`}
      dangerouslySetInnerHTML={{ __html: childText }}
    ></div>
  );
};

export default LessonPlanText;
